import React from 'react';
import { motion } from 'framer-motion';
export function TruthSection() {
  return <section className="py-16 px-4 bg-black text-white" data-id="element-242">
      <div className="max-w-3xl mx-auto text-center" data-id="element-243">
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} data-id="element-244">
          <div className="inline-block bg-red-600 text-white font-black text-2xl md:text-3xl px-6 py-3 rounded-lg mb-8 transform -rotate-2" data-id="element-245">
            ⚠️ La verdad que nadie te dice
          </div>

          <h3 className="text-3xl md:text-4xl font-black mb-4 text-yellow-400" data-id="element-246">
            No fallaste vos.
          </h3>
          <h4 className="text-2xl md:text-3xl font-bold mb-10" data-id="element-247">
            Fallaron los métodos.
          </h4>

          <p className="text-xl mb-6 text-gray-300" data-id="element-248">Porque:</p>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 max-w-2xl mx-auto mb-10 text-left" data-id="element-249">
            {['las dietas son complicadas', 'te hacen contar calorías', 'te sacan todo lo que te gusta', 'no son sostenibles'].map((item, index) => <div key={index} className="bg-gray-900 p-4 rounded-lg border border-gray-800 flex items-center gap-3" data-id="element-250">
                <span className="text-red-500 text-xl" data-id="element-251">❌</span>
                <span className="text-lg font-medium" data-id="element-252">{item}</span>
              </div>)}
          </div>

          <p className="text-2xl font-bold text-yellow-400 bg-gray-900 inline-block px-6 py-3 rounded-full border border-yellow-400/30" data-id="element-253">
            Y por eso siempre terminás en el mismo lugar.
          </p>
        </motion.div>
      </div>
    </section>;
}